import classNames from 'classnames/bind';
import styles from './ShareLink.module.css';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

import { isLoggedIn, setToken } from '../../utils/storage';
import { openSelpubCloud } from '../../utils/selpub';
import useModal from '../../hooks/useModal';
import {
  CONTACT_LINK_SHARER,
  LINK_PWD,
  MOVE_TO_SELPUB,
  UNAVAILABLE_LINK_MESSAGE,
} from '../../constants';
import { guestApiSlice, useGetGuestTokenMutation } from '../../services/guest';
import { download } from '../../utils/util';
import { useAppSelector } from '../../hooks/useRedux';
import { selectTokens } from '../../features/authSlice';

export default function ShareLink() {
  const cx = classNames.bind(styles);

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const link = params.get('link');
  const isResource = params.get('resourceYn') === '1';

  const [getGuestLink] = guestApiSlice.useLazyGetGuestLinkQuery();
  const [getResourceLink] = guestApiSlice.useLazyGetResourceLinkQuery();
  const [getGuestToken] = useGetGuestTokenMutation();

  const navigate = useNavigate();
  const { toggleModal } = useModal();

  const [isExpired, setIsExpired] = useState(false);
  const [isError, setIsError] = useState(false);

  const tokens = useAppSelector(selectTokens);

  const setGuestToken = async () => {
    try {
      const res = await getGuestToken();
      if ('data' in res) {
        setToken(res.data);
      }
    } catch (error) {
      console.error('failed to get guest token', error);
    }
  };

  const openPwdModal = (projectId: number, isResource?: boolean) => {
    toggleModal({
      name: LINK_PWD,
      id: 'linkPassword',
      type: 'alert',
      isOpen: true,
      initialButtonDisabled: true,
      data: { link, projectId, isResource },
    });
  };

  const getLinkData = async () => {
    try {
      const res = await (isResource ? getResourceLink : getGuestLink)(
        link as string
      );
      const { expYn, projectId, pwdYn, resourceId } = res.data;

      setIsExpired(expYn);

      if (!expYn) {
        if (isLoggedIn) {
          if (pwdYn) {
            openPwdModal(isResource ? resourceId : projectId, isResource);
          } else {
            isResource
              ? (download(resourceId, true), navigate('/home'))
              : (navigate('/home', {
                  replace: true,
                  state: { isSharedLink: true },
                }),
                setToken(tokens),
                openSelpubCloud('viewer', projectId, true));
          }
        } else {
          if (isResource) {
            pwdYn
              ? openPwdModal(resourceId, true)
              : (download(resourceId, true), navigate('/'));
          } else {
            setGuestToken();
            navigate('/login', {
              state: {
                link,
                hasLinkPwd: pwdYn,
                userType: 'guest',
                projectId,
                resourceId,
              },
            });
          }
        }
      }
    } catch (error) {
      console.error('Failed to get link data', error);
      setIsError(true);
    }
  };

  useEffect(() => {
    getLinkData();
  }, []);

  return (
    <>
      {isExpired || isError ? (
        <div className={cx('container')}>
          <h1>{UNAVAILABLE_LINK_MESSAGE}</h1>
          <p>{CONTACT_LINK_SHARER}</p>
          <hr />
          <button type="button" className={cx('btn', 'b_t')}>
            <span>
              <Link to="/">{MOVE_TO_SELPUB}</Link>
            </span>
          </button>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
